module.exports = __webpack_public_path__ + "static/img/part_06b.4b78339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pomelo/part_06b.png
// module id = Izee
// module chunks = 6